import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJeepComponent } from './simple-icons-jeep.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJeepComponent ],
    exports:      [ SimpleIconsJeepComponent ],
    bootstrap:    []
})
export class SimpleIconsJeepModule {}
